module.exports = __webpack_public_path__ + "1fa8a0192f61342871716b676f8fc5f0.svg";